import { API_VERSIONS } from "../utils/constants";
import RequestHandler from "./RequestHandler";

function UnitConversionAPI() {
    const baseUnitConversionsAPI = "unit-conversions";

    async function addConversionUnit(payload) {
        try {
            const result = await RequestHandler.post(
                `${API_VERSIONS.v1}/${baseUnitConversionsAPI}`,
                payload
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function updateConversionUnit(payload) {
        try {
            const result = await RequestHandler.put(
                `${API_VERSIONS.v1}/${baseUnitConversionsAPI}`,
                payload
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function removeConversionUnit(conversionUnitId) {
        try {
            const result = await RequestHandler.remove(
                `${API_VERSIONS.v1}/${baseUnitConversionsAPI}/${conversionUnitId}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }
    return {
        addConversionUnit,
        updateConversionUnit,
        removeConversionUnit,
    };
}

export default UnitConversionAPI();
